<script setup lang="ts">
import {onBeforeMount, type PropType, ref} from "vue";
import NamaCommon from "@/utils/common/NamaCommon";
import {useInterval} from "@vueuse/core";
import DTOUserNotification = namaTypes.DTOUserNotification;

let props = defineProps({
  notification: {
    type: Object as PropType<DTOUserNotification>,
    required: true
  }
});

let timeDiff = ref("");

onBeforeMount(() => {
  timeDiff.value = NamaCommon.getDateDifferenceAsString(props.notification.submittedOn!);
})

useInterval(60000, {
  callback() {
    timeDiff.value = NamaCommon.getDateDifferenceAsString(props.notification.submittedOn!);
  },
})
</script>

<template>
  <div class="tw-w-full tw-flex tw-gap-[13px] tw-px-[14px] tw-py-[13px] tw-cursor-pointer
        tw-border-b tw-border-[#bfc6d1] dark:tw-border-[#5f6a78]
        hover:tw-bg-[rgba(255,255,255,.38)] dark:hover:tw-bg-[rgba(255,255,255,.07)]">
    <div class="tw-flex-1 tw-min-w-0 tw-flex tw-flex-col tw-gap-[3px]">
      <div class="nama-notif-title tw-text-[13.5px] tw-font-bold tw-leading-[1.5] tw-text-namaFontColor-input-light dark:tw-text-namaFontColor-input-dark"
           v-html="notification.subject"></div>
      <div v-if="notification.body" class="tw-w-full tw-max-h-[calc(50vh-var(--navbar-height))]" data-scrollbar-reveal>
        <div class="tempo-tooltip-content tw-text-[12.5px] tw-leading-[1.6] tw-text-[#4b5563] dark:tw-text-gray-300"
             v-html="notification.body"></div>
      </div>
      <div class="tw-mt-[3px] tw-text-[11.5px] tw-text-[#4b5563] dark:tw-text-[#c3cbd6]"
           v-text="timeDiff"></div>
    </div>
    <div class="tw-w-2 tw-flex tw-shrink-0 tw-justify-center tw-pt-[7px]">
      <div class="tw-size-[7px] tw-rounded-full tw-bg-[#2563eb] dark:tw-bg-[#3b82f6]"></div>
    </div>
  </div>
</template>

<style scoped>
.nama-notif-title {
  text-wrap: pretty;
}
</style>
